import { entries } from "lodash-es";

import { toHierarchicalFacetPath } from "@services/bffSearch/responseTransformers/mergeHierarchicalFacets.transformer";

import { Facet } from "@components/Search/SearchResults/StateComponents/Facets/Facet/@types/facet.types";
import {
    FacetType,
    RecursiveHierarchicalFacet,
} from "@components/Search/SearchResults/StateComponents/Facets/Facet/@types/facetType.types";
import { FACET_DELIMITER } from "@components/Search/SearchResults/StateComponents/Facets/Facet/facet.configuration";

export const extractValue = (formattedValue: string) => {
    const [_, identifier, textValue] = formattedValue.split(FACET_DELIMITER);

    return {
        identifier: identifier,
        textValue: textValue,
    };
};

export const facetValuesOfCategoryPageId = (
    facet: Facet<FacetType.HIERARCHICAL>,
    categoryPageIdFilter?: string,
): Record<string, RecursiveHierarchicalFacet> => {
    const facetValues = entries(facet.values);

    return facetValues.length === 1 &&
        extractValue(facetValues[0][0]).identifier === categoryPageIdFilter
        ? facetValues[0][1].childValues
        //@ts-ignore
        : facet.values;
};

export const getShowAllCategories = (
    selectedValue?: string,
    categoryPageIdFilter?: string,
) =>
    categoryPageIdFilter && selectedValue
        ? extractValue(toHierarchicalFacetPath(selectedValue).at(-1) ?? "")
              .identifier !== categoryPageIdFilter
        : true;
